import React, { useEffect, useState, useRef } from "react";
import {
  PaginationTable,
  SwitchButtonComponet,
  TextIconButtonComponent,
} from "../../../component/atom";
import { Box, Grid, LinearProgress, Stack } from "@mui/material";
import HeadingComponent from "../../../component/atom/Headings/Heading";
import DropDownComponent from "../../../component/atom/Inputs/DropDown";
import DialogComponent from "../../../component/atom/Dialog/Dialog";
import AddStudentForm from "../../../component/molecule/Forms/AddStudentForm";
import {
  faUserPlus,
  faLaptop,
  faRotateLeft,
  faCommentDots,
} from "@fortawesome/free-solid-svg-icons";
import { connect } from "react-redux";
import { Actions } from "../../../core/modules/Actions";
import TextButtonComponet from "../../../component/atom/Buttons/TextButton";
import AddReviewForm from "../../../component/molecule/Forms/courseAdmin/AdminAddReviewForm";
import {
  ResetDeviceIdForm,
  ResetCourseProgressForm,
  AddRandomReviewForm,
  EditStudentForm,
} from "../../../component/molecule/Forms";
import ConfirmationDialog from "../../../component/molecule/Dialog/ConfirmationDialog";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import axios from "axios";
import { baseURL } from "../../../core/repository/Repository";

const StudentsScreen = ({
  getAdminUserDetails,
  adminStudents,
  courseList,
  getCourseList,
  studentStatus,
  updateStudentStatus,
  coursecatalog,
  getCousreCatalog,
  getAllAdminUserDetails,
  adminAllStudents,
  deleteStudent,
  studentUpdateResponse,
  studentDeleteResponse,
  getAvailableCoursesForReview,
  availableCoursesForReview,
  courseProgressResetResponse,
}) => {
  const [addStudent, setAddStudent] = useState(false);
  const [editStudent, setEditStudent] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [openReview, setOpenReview] = useState(false);
  const [openRandomReview, setOpenRandomReview] = useState(false);
  const [resetDeviceId, setResetDeviceId] = useState(false);
  const [resetCourseProgress, setResetCourseProgress] = useState(false);
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [studentToDelete, setStudentToDelete] = useState(null);
  const [studentList, setStudentList] = useState([]);
  const [courseId, setCourseId] = useState(0);
  const [studentId, setStudentId] = useState(0);
  const [studentPaymentData, setStudentPaymentData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0); // New state for total records
  const [searchQuery, setSearchQuery] = useState("");
  const [studentAllList, setStudentAllList] = useState([]);

  const initialFetchDone = useRef(false);
  const navigate = useNavigate();

  const onNavigate = (path, obj = {}) => {
    if (path) {
      navigate(path, obj);
    }
  };

  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func(...args), delay);
    };
  };

  const fetchStudents = (page, perPage, course, search = "") => {
    console.log("Fetching students for page:", page);
    getAdminUserDetails({
      course: course === 0 ? "" : course,
      type: 2,
      page,
      per_page: perPage,
      search: search.trim(),
    });
  };

  const debouncedFetchStudents = useRef(debounce(fetchStudents, 300)).current;

  useEffect(() => {
    if (!initialFetchDone.current) {
      fetchStudents(currentPage, rowsPerPage, courseId, searchQuery);
      initialFetchDone.current = true;
    }
  }, []);

  useEffect(() => {
    if (initialFetchDone.current) {
      debouncedFetchStudents(currentPage, rowsPerPage, courseId, searchQuery);
    }
  }, [currentPage, rowsPerPage, courseId, searchQuery]);

  useEffect(() => {
    if (adminStudents) {
      console.log("adminStudents received:", adminStudents);
      const data = adminStudents.data || adminStudents;
      setStudentList(data);

      // Set total items (total records)
      if (adminStudents.total) {
        setTotalItems(adminStudents.total); // 3291
      }

      // Set total pages for internal tracking
      if (adminStudents.total && adminStudents.per_page) {
        const calculatedTotalPages = Math.ceil(
          adminStudents.total / adminStudents.per_page
        );
        console.log("Calculated total pages:", calculatedTotalPages);
        setTotalPages(calculatedTotalPages); // 330
      } else if (adminStudents.last_page) {
        console.log("Using last_page:", adminStudents.last_page);
        setTotalPages(adminStudents.last_page); // 330
      }

      if (adminStudents.per_page && adminStudents.per_page !== rowsPerPage) {
        setRowsPerPage(adminStudents.per_page);
      }
    }
  }, [adminStudents]);

  useEffect(() => {
    getCourseList();
    getCousreCatalog();
  }, []);

  useEffect(() => {
    if (studentUpdateResponse && studentUpdateResponse.status_code === 1) {
      fetchStudents(currentPage, rowsPerPage, courseId, searchQuery);
    }
  }, [studentUpdateResponse]);

  useEffect(() => {
    if (studentDeleteResponse && studentDeleteResponse.status_code === 1) {
      fetchStudents(currentPage, rowsPerPage, courseId, searchQuery);
    }
  }, [studentDeleteResponse]);

  const onNavigateUser = (tableMeta, value) => {
    for (const item of studentList) {
      if (item?.id == tableMeta?.rowData[0]) {
        onNavigate("/admin-course-student-progress", {
          state: { studentId: _.get(item, "id", ""), student: item },
        });
      }
    }
  };

  useEffect(() => {
    setStudentAllList(adminAllStudents.data || []);
  }, [adminAllStudents]);

  // Fetch fresh data when course progress is reset successfully
  useEffect(() => {
    if (
      courseProgressResetResponse &&
      courseProgressResetResponse.status_code === 1
    ) {
      fetchStudents(currentPage, rowsPerPage, courseId, searchQuery);
    }
  }, [courseProgressResetResponse]);

  const handleDownloadAll = async () => {
    try {
      const recordCount = totalItems;

      const allStudents = await axios.post(
        baseURL + "api/v1/admin/users/fetch",
        {
          course: courseId === 0 ? "" : courseId,
          type: 2,
          page: 1,
          per_page: recordCount,
          search: "",
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );

      // const allStudents = await getAllAdminUserDetails({
      //   course: courseId === 0 ? "" : courseId,
      //   type: 2,
      //   page: 1,
      //   per_page: recordCount,
      //   search: "",
      // });

      // use the data returned directly
      return allStudents?.data?.data?.data || [];
    } catch (error) {
      console.error("Download data fetch failed:", error);
      return [];
    }
  };

  const columns = [
    { name: "id", label: "ID", options: { filter: true, sort: false } },
    {
      name: "course_id",
      label: "",
      options: { filter: true, sort: false, display: false },
    },
    {
      name: "first_name",
      label: "First Name",
      options: { filter: true, sort: false },
    },
    {
      name: "last_name",
      label: "Last Name",
      options: { filter: true, sort: false },
    },
    { name: "email", label: "Email", options: { filter: true, sort: false } },
    {
      name: "whatsapp_phone_number",
      label: "WhatsApp number",
      options: { filter: false, sort: false },
    },
    {
      name: "course_progress",
      label: "Enrolled Course",
      options: {
        filter: true,
        sort: false,
        display: true,
        customBodyRender: (value, tableMeta) => {
          const courses = Array.isArray(value) ? value : [value];

          if (!courses.length) return "-";

          return (
            <ul style={{ margin: 0, paddingLeft: 16 }}>
              {courses.map((item, idx) => (
                <li key={`${tableMeta.rowIndex}-${item.course?.id || idx}`}>
                  {item.course?.name || "Unnamed Course"}
                </li>
              ))}
            </ul>
          );
        },
      },
    },
    {
      name: "course_progress",
      label: "Progress",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const progressData = Array.isArray(value) ? value : [value];
          return (
            <Stack spacing={1}>
              {progressData.map((progress, index) => (
                <Box key={index} sx={{ display: "flex", alignItems: "center" }}>
                  <LinearProgress
                    variant="determinate"
                    value={progress?.progress || 0}
                    sx={{ width: "100%", marginRight: 1 }}
                  />
                  <span>{`${Math.round(progress?.progress || 0)}%`}</span>
                </Box>
              ))}
            </Stack>
          );
        },
      },
    },
    {
      name: "is_active",
      label: "Status",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta) => (
          <SwitchButtonComponet
            checked={value ? true : false}
            onChange={() => updateAdminStatus(tableMeta, value)}
            inputProps={{ "aria-label": "controlled" }}
          />
        ),
      },
    },
    {
      name: "id",
      label: "Add Review",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => (
          <Box sx={{ minWidth: 150 }}>
            <TextButtonComponet
              text={"Add Review"}
              onButtonClick={() => addReviewBtn(value, tableMeta)}
            />
          </Box>
        ),
      },
    },
    {
      name: "id",
      label: "Progress",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => (
          <Box sx={{ minWidth: 100 }}>
            <TextButtonComponet
              text={"View Progress"}
              onButtonClick={() => onNavigateUser(tableMeta, value)}
            />
          </Box>
        ),
      },
    },
    {
      name: "id",
      label: "Edit",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => (
          <Box sx={{ minWidth: 80 }}>
            <TextIconButtonComponent
              btnText={"Edit"}
              onclick={() => handleEditStudent(tableMeta)}
            />
          </Box>
        ),
      },
    },
    {
      name: "id",
      label: "Delete",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => (
          <Box sx={{ minWidth: 80 }}>
            <TextIconButtonComponent
              btnText={"Delete Review"}
              onclick={() => handleDeleteStudent(tableMeta)}
            />
          </Box>
        ),
      },
    },
  ];

  const updateAdminStatus = (tableMeta) => {
    const updatedStudents = studentList?.map((item) => {
      if (item?.id == tableMeta?.rowData[0]) {
        const currentStatus = item?.is_active;
        const updatedStatus = currentStatus == 1 ? 0 : 1;
        updateStudentStatus({
          user_id: tableMeta?.rowData[0],
          status: updatedStatus,
        });
        return { ...item, is_active: updatedStatus };
      }
      return item;
    });
    setStudentList(updatedStudents);
  };

  const filterStudentsDetails = (courseId) => {
    setCourseId(courseId);
    setCurrentPage(1);
    debouncedFetchStudents(1, rowsPerPage, courseId, searchQuery);
  };

  const addReviewBtn = (value, tableMeta) => {
    setStudentId(value);
    setCourseId(tableMeta?.rowData[1]);
    setStudentPaymentData(tableMeta?.rowData[6]);
    getAvailableCoursesForReview(value);
    setOpenReview(true);
  };

  const handleCloseRandomReview = () => {
    setOpenRandomReview(false);
  };

  const handleEditStudent = (tableMeta) => {
    const student = studentList.find((item) => item?.id == tableMeta?.rowData[0]);
    if (student) {
      setSelectedStudent(student);
      setEditStudent(true);
    }
  };

  const handleDeleteStudent = (tableMeta) => {
    const studentId = tableMeta?.rowData[0];
    const student = studentList.find((item) => item?.id == studentId);
    setStudentToDelete({ id: studentId, name: `${student?.first_name} ${student?.last_name}` });
    setDeleteConfirmOpen(true);
  };

  const confirmDelete = () => {
    if (studentToDelete) {
      deleteStudent(studentToDelete.id);
      setDeleteConfirmOpen(false);
      setStudentToDelete(null);
    }
  };

  const cancelDelete = () => {
    setDeleteConfirmOpen(false);
    setStudentToDelete(null);
  };

  return (
    <>
      <Box className="main-screen-container">
        <Grid container direction="row" justifyContent="space-between">
          <Grid item>
            <HeadingComponent
              text={"Students"}
              fontweigth={600}
              size={40}
              fontfamily={"Montserrat"}
            />
          </Grid>
          <Grid item className="student-search-btn-section">
            <Box style={{ marginRight: 10 }}>
              <TextIconButtonComponent
                buttonStyleClass="btn btn-primary"
                icon={faLaptop}
                btnText={"Reset device id"}
                onclick={() => setResetDeviceId(true)}
              />
            </Box>
            <Box style={{ marginRight: 10 }}>
              <TextIconButtonComponent
                buttonStyleClass="btn btn-primary"
                icon={faRotateLeft}
                btnText={"Reset Course Progress"}
                onclick={() => setResetCourseProgress(true)}
              />
            </Box>
            <Box style={{ marginRight: 10 }}>
              <TextIconButtonComponent
                buttonStyleClass="btn btn-primary"
                icon={faCommentDots}
                btnText={"Add Random Review"}
                onclick={() => setOpenRandomReview(true)}
              />
            </Box>
            <TextIconButtonComponent
              buttonStyleClass="btn btn-primary"
              icon={faUserPlus}
              btnText={"Add Student"}
              onclick={() => setAddStudent(true)}
            />
            <Box className="student-search-btn-inner-section">
              <DropDownComponent
                list={courseList}
                initialValue={"All Courses"}
                selectedValue={courseId}
                onchange={(e) => filterStudentsDetails(e.target.value)}
                placeholder={"All Courses"}
              />
            </Box>
          </Grid>
        </Grid>

        <Box className="common-admin-content-wrap">
          <PaginationTable
            columns={columns}
            data={studentList}
            totalItems={totalItems} // Pass total records (3291)
            currentPage={currentPage}
            rowsPerPage={rowsPerPage}
            onPageChange={(page) => {
              console.log("Page change requested to:", page);
              setCurrentPage(page);
            }}
            onRowsPerPageChange={(perPage) => {
              console.log("Rows per page changed to:", perPage);
              setRowsPerPage(perPage);
              setCurrentPage(1);
            }}
            onSearchChange={(searchText) => {
              console.log("Search query changed to:", searchText);
              setSearchQuery(searchText);
            }}
            onDownloadData={handleDownloadAll}
            name={"students"}
          />
        </Box>
      </Box>

      <DialogComponent
        title={"Reset Device Id"}
        children={
          <ResetDeviceIdForm onclickcancel={() => setResetDeviceId(false)} />
        }
        onClose={() => setResetDeviceId(false)}
        open={resetDeviceId}
      />

      <DialogComponent
        title={"Reset Course Progress"}
        children={
          <ResetCourseProgressForm
            onclickcancel={() => setResetCourseProgress(false)}
            onSuccess={() => setResetCourseProgress(false)}
          />
        }
        onClose={() => setResetCourseProgress(false)}
        open={resetCourseProgress}
      />

      <DialogComponent
        title={"Add Student"}
        children={
          <AddStudentForm
            dropdownList={courseList}
            onclickcancel={() => setAddStudent(false)}
          />
        }
        onClose={() => setAddStudent(false)}
        open={addStudent}
      />
      <DialogComponent
        title={"Edit Student"}
        children={
          <EditStudentForm
            studentData={selectedStudent}
            onclickcancel={() => {
              setEditStudent(false);
              setSelectedStudent(null);
            }}
          />
        }
        onClose={() => {
          setEditStudent(false);
          setSelectedStudent(null);
        }}
        open={editStudent}
      />
      <DialogComponent
        title={"Add Review"}
        children={
          <AddReviewForm
            courseId={courseId}
            courses={availableCoursesForReview}
            userId={studentId}
            dropdownList={courseList}
            onclickcancel={() => setOpenReview(false)}
          />
        }
        onClose={() => setOpenReview(false)}
        open={openReview}
      />
      <DialogComponent
        title={"Add Random Review"}
        children={
          <AddRandomReviewForm
            courseList={courseList}
            onclickcancel={handleCloseRandomReview}
            open={openRandomReview}
          />
        }
        onClose={handleCloseRandomReview}
        open={openRandomReview}
      />
      <DialogComponent
        title={"Delete Student"}
        children={
          <ConfirmationDialog
            message={`Are you sure you want to delete ${studentToDelete?.name || "this student"} reviews?`}
            description="This action cannot be undone. All student review data will be permanently removed."
          />
        }
        onClose={cancelDelete}
        open={deleteConfirmOpen}
        btntextone="Delete"
        btntexttwo="Cancel"
        onclickone={confirmDelete}
        backgroundColor="#DC3545"
      />
    </>
  );
};

export default connect(
  (state) => ({
    adminStudents: state.students.get("adminStudents"),
    courseList: state.students.get("commonCourseList"),
    studentStatus: state.students.get("studentStatusUpdate"),
    coursecatalog: state.course.get("coursecatalog"),
    adminAllStudents: state.students.get("adminAllStudents"),
    studentUpdateResponse: state.students.get("studentUpdateResponse"),
    studentDeleteResponse: state.students.get("studentDeleteResponse"),
    availableCoursesForReview: state.review.get("availableCoursesForReview"),
    courseProgressResetResponse: state.students.get("courseProgressResetResponse"),
  }),
  {
    getAdminUserDetails: Actions.students.getAdminUserDetails,
    getCourseList: Actions.students.getCourseList,
    updateStudentStatus: Actions.students.updateStudentStatus,
    getCousreCatalog: Actions.course.getCousreCatalog,
    getAllAdminUserDetails: Actions.students.getAllAdminUserDetails,
    deleteStudent: Actions.students.deleteStudent,
    getAvailableCoursesForReview: Actions.review.getAvailableCoursesForReview,
  }
)(StudentsScreen);
